import React from "react";

export const scribbleFilled = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M4.318 19.682C3 18.364 3 16.242 3 12s0-6.364 1.318-7.682S7.758 3 12 3s6.364 0 7.682 1.318S21 7.758 21 12s0 6.364-1.318 7.682S16.242 21 12 21s-6.364 0-7.682-1.318"
      />
      <path
        fill="currentColor"
        d="M12 3c4.242 0 6.364 0 7.682 1.318S21 7.758 21 12s0 6.364-1.318 7.682S16.242 21 12 21s-6.364 0-7.682-1.318S3 16.242 3 12s0-6.364 1.318-7.682S7.758 3 12 3m5.53 6.47a.75.75 0 0 0-1.06 0l-2.793 2.793a.25.25 0 0 1-.354 0l-1.586-1.586a1.75 1.75 0 0 0-2.346-.117l-.128.117L6.47 13.47a.75.75 0 1 0 1.06 1.06l2.793-2.793a.25.25 0 0 1 .354 0l1.586 1.586.128.117a1.75 1.75 0 0 0 2.346-.117l2.793-2.793a.75.75 0 0 0 0-1.06"
      />
    </svg>
  );
};
